/**
 * 评价模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取评价列表
export const evaluateList = (params) => {
  return req.get('/order/evaluation/listNew', params);
}
//获取评价详情
export const getEvaluate = (orderId) => {
  return req.get(`/order/evaluation/${orderId}`);
}

// 隐藏评价
export const evaluateHide = (params) => {
  return req.put('/order/evaluation/updateShowStatus', params);
}

// 回复评价
export const evaluateReply = (params) => {
  return req.put('/order/evaluation', params);
}
// 订单评价导出
export const evaluateExport = (params,customConfig) => {
  return req.downloadGet('/order/evaluation/exportNew', params,customConfig,'application/vnd.ms-excel');
}

// 配药服务评价导出
export const prescriptionEvaluationExport = (params,customConfig) => {
  return req.downloadGet('/order/evaluation/prescription/export', params,customConfig,'application/vnd.ms-excel');
}

// 下载医生评价导入模板
export const evaluateImportTemplate = (customConfig) => {
  return req.downloadGet('/order/evaluation/doctor/importTemplate', {}, customConfig, 'application/vnd.ms-excel');
}

// 导入医生评价
export const evaluateImport = (params) => {
  return req.uploadPost('/order/evaluation/doctor/import', params, '/api', { 'Content-Type': 'multipart/form-data' });
}

//分页查询配药服务评价
export const prescriptionEvaluationList = (params) => {
  return req.post('/order/evaluation/prescription/page', params);
}
